export default Object.freeze({
  Remote: 1,
  LocalProcess: 2,
});
